/**
 * AI System Configuration
 * Controls which AI system to use across the application
 */

export interface AIConfig {
  useUnifiedAI: boolean;
  enableDocumentUpload: boolean;
  enableAnalytics: boolean;
  enableAdminFeatures: boolean;
  defaultContext: 'general' | 'underwriting';
  autoDetectContext: boolean;
}

// Default configuration - can be overridden by environment variables
export const defaultAIConfig: AIConfig = {
  useUnifiedAI: true, // Enable unified AI by default
  enableDocumentUpload: true,
  enableAnalytics: true,
  enableAdminFeatures: false, // Controlled per component
  defaultContext: 'general',
  autoDetectContext: true,
};

// Environment-based configuration
export const getAIConfig = (): AIConfig => {
  return {
    useUnifiedAI: process.env.NEXT_PUBLIC_USE_UNIFIED_AI !== 'false',
    enableDocumentUpload: process.env.NEXT_PUBLIC_ENABLE_DOCUMENT_UPLOAD !== 'false',
    enableAnalytics: process.env.NEXT_PUBLIC_ENABLE_AI_ANALYTICS !== 'false',
    enableAdminFeatures: false, // Always controlled per component
    defaultContext: (process.env.NEXT_PUBLIC_DEFAULT_AI_CONTEXT as 'general' | 'underwriting') || 'general',
    autoDetectContext: process.env.NEXT_PUBLIC_AUTO_DETECT_CONTEXT !== 'false',
  };
};

// Runtime configuration (can be changed without rebuild)
export let runtimeAIConfig: AIConfig = getAIConfig();

export const updateAIConfig = (updates: Partial<AIConfig>) => {
  runtimeAIConfig = { ...runtimeAIConfig, ...updates };
};

export const getCurrentAIConfig = (): AIConfig => runtimeAIConfig;
